import KAD from './coordinates/Sankt-Peterburg/KAD.json';
import Devyatkino from './coordinates/Sankt-Peterburg/Devyatkino.json';
import Petrodvorcoviy from './coordinates/Sankt-Peterburg/Petrodvorcoviy.json';
import Kronshtadskiy from './coordinates/Sankt-Peterburg/Kronshtadskiy.json';
import Kurortniy from './coordinates/Sankt-Peterburg/Kurortniy.json';

export default {
    regionCode: 'spb',
    serviceAreas: [
        {
            id: 'spb-1',
            include: [
                {
                    name: 'КАД',
                    type: 'polygon',
                    coordinates: KAD,
                },
                {
                    name: 'район Девяткино',
                    type: 'polygon',
                    coordinates: Devyatkino,
                }
            ],
            exclude: [
                {
                    name: 'Петродворцовый район',
                    type: 'polygon',
                    coordinates: Petrodvorcoviy,
                },
                {
                    name: 'Кронштадский район',
                    type: 'polygon',
                    coordinates: Kronshtadskiy,
                },
                {
                    name: 'Курортный район',
                    type: 'polygon',
                    coordinates: Kurortniy,
                }
            ]
        },
    ],
};
